import Banner from './Banner'
import AppLogo from './AppLogo'
import InputEmail from './InputEmail'
import InputPassword from './InputPassword'
import ButtonLogin from './ButtonLogin'
import TablePagination from './TablePagination'
import PagingButton from './PagingButton'
import PictureAdapter from './PictureAdapter'

export {
    Banner,
    AppLogo,
    InputEmail,
    InputPassword,
    ButtonLogin,
    TablePagination,
    PagingButton,
    PictureAdapter
}


// WEBPACK FOOTER //
// ./src/components/elements/index.js